<template>
    <list-cell-icon
        :icon="icon"
        is-custom-icon
    />
</template>

<script setup lang="ts">
    import { Channel } from '@keyvue/one-api-client';
    import { ListCellIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';

    import IconChannelOnline from '@assets/icons/channels/ChannelOnline.svg?component';
    import IconChannelRealworks from '@assets/icons/channels/ChannelRealworks.svg?component';
    import IconChannelUser from '@assets/icons/channels/ChannelUser.svg?component';

    const props = defineProps<{
        channel: Channel,
    }>();

    const iconMap = {
        [Channel.USER.value]: IconChannelUser,
        [Channel.ONLINE.value]: IconChannelOnline,
        [Channel.REALWORKS.value]: IconChannelRealworks,
    };

    const icon = computed(() => iconMap[props.channel.value]);
</script>
